import React from 'react';
import { THead } from './THead';
import { TRow } from './TRow';
import { TCell } from './TCell';
import { TBody } from './TBody';

import './table.css';

export const DataTable = ({
  heads,
  bodyMap,
  data,
}) => {
  return (
    <section className="data-table">
      <THead>
        <TRow>
          {heads.map(({ render, name, title }) => {
            return (<TCell key={name+title}>{render}</TCell>);
          })}
        </TRow>
      </THead>
      <TBody>
        {data.map(item => (
          <TRow key={item.id}>
            {heads.map(({ name }) => (
              <TCell key={name}>
                {bodyMap[name](item)}
              </TCell>
            ))}
          </TRow>
        ))}
      </TBody>
    </section>
  );
};
